import { useEffect } from 'react';
import { Button, useBreakpointValue } from '@chakra-ui/react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount, useSignMessage } from 'wagmi';

const isKeyMintAvailiable = process.env.REACT_APP_MINT_AVAILIABLE === 'true';

export const CustomConnectButton = (props) => {
	const isMobile = useBreakpointValue({ base: true, md: false });
	const { address } = useAccount();
	const { signMessage, data, error } = useSignMessage();

	const handleLogin = async (address) => {
		if (!address) return;

		const message = `Sign this message to login. Address: ${address}`;

		try {
			const signature = await signMessage({ message });
			// localStorage.setItem('userSignature', signature);
			// console.log('Signature saved:', signature);
		} catch (error) {
			console.error('Error signing message:', error);
		}
	};

	useEffect(() => {
		const userSignature = localStorage.getItem('userSignature');
		if (data) {
			localStorage.setItem('userSignature', data);
		} else if (!userSignature) {
			handleLogin(address);
		}
	}, [data, address])

	return (
		isKeyMintAvailiable && <ConnectButton.Custom>
			{({
				account,
				chain,
				openAccountModal,
				openChainModal,
				openConnectModal,
				authenticationStatus,
				mounted,
			}) => {
				const ready = mounted && authenticationStatus !== 'loading';
				const connected =
					ready &&
					account &&
					chain &&
					(!authenticationStatus || authenticationStatus === 'authenticated');

				return (
					<div
						{...(!ready && {
							'aria-hidden': true,
							style: {
								opacity: 0,
								pointerEvents: 'none',
								userSelect: 'none',
							},
						})}
					>
						{(() => {
							if (!connected) {
								return (
									<Button
										onClick={openConnectModal}
										type="button"
										bg={"#FEEFDD"}
										_hover={{ background: "#EADBCD" }}
										height={!isMobile ? "38px" : "35px"}
										size={!isMobile ? 'md' : 'xs'}
										{...props}
									>
										Connect Wallet
									</Button>
								);
							}
							if (chain.unsupported) {
								return (
									<Button
										onClick={openChainModal}
										type="button"
										bg={"#FEEFDD"}
										_hover={{ background: "#EADBCD" }}
										height={!isMobile ? "38px" : "35px"}
										size={!isMobile ? 'md' : 'xs'}
									>
										Wrong network
									</Button>
								);
							}
							return (
								<div style={{ display: 'flex', gap: 12 }}>
									<Button
										onClick={openAccountModal}
										type="button"
										bg={"#FEEFDD"}
										_hover={{ background: "#EADBCD" }}
										height={!isMobile ? "38px" : "35px"}
										size={!isMobile ? 'md' : 'xs'}
									>
										{account.displayName}
										{account.displayBalance
											? ` (${account.displayBalance})`
											: ''}
									</Button>
								</div>
							);
						})()}
					</div>
				);
			}}
		</ConnectButton.Custom>
	);
};

export default CustomConnectButton;